import useCodeSnippet from "./useCodeSnippet";
import ICON_TYPES from "../../../../../src/js/misc/IconTypes";
import {isObservableArray, isObservableObject, toJS} from "mobx";
import isArray from "lodash/isArray";

const createMenuItemConfig = menuItem => {
	menuItem.onClick = useCodeSnippet(menuItem.onClick);
	switch (menuItem.iconType) {
		case ICON_TYPES.NONE:
			menuItem.icon = null;
			break;
		case ICON_TYPES.FUNCTION:
			menuItem.icon = useCodeSnippet(menuItem.iconFunction);
			break;
		case ICON_TYPES.STRING:
			menuItem.icon = menuItem.iconString;
			break;
		case ICON_TYPES.URL:
			menuItem.icon = menuItem.iconUrl;
			break;
		case ICON_TYPES.DOMNODE:
			menuItem.icon = utahHeader.renderDOM(menuItem.iconDom);
			break;
		default:
			console.error(`updateHeaderWithConfig: Unknown icon menu type: ${menuItem.iconType}`);
			break;
	}
	menuItem.children = menuItem.children.map(createMenuConfig);
	return menuItem;
};

export default function createMenuConfig(menu) {
	let result;

	// is it a MobX observable?
	if (isObservableObject(menu) || isObservableArray(menu)) {
		// toJS converts to plain Javascript object
		// recurse so it can handle single menu item or an array of items naturally
		result = createMenuConfig(toJS(menu));

	} else if (isArray(menu)) {
		result = menu.map(createMenuItemConfig);

	} else {
		result = createMenuItemConfig(menu);
	}

	return result;
}
